export const pageSettings = {
  pageSize: 50,
  current: 1,
  hideOnSinglePage: true,
  showTitle: false,
};
